import { useRef, useState } from "react";
import { Button, Progress, Space } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

/**
 * Dosya seçtirip verilen yükleyiciyi çağırır. Yükleme ilerlemesini butonun altında gösterir.
 * upload: (file, onProgress) => Promise
 * accept: dosya seçicinin uzantı filtresi; kurulum dosyaları için zip dışına çıkar.
 */
export default function ArtifactUploadButton({ upload, onUploaded, disabled, label, size, accept = '.zip' }) {
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const [percent, setPercent] = useState(null);

    const handleChange = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = '';
        if (!file) return;

        setPercent(0);
        try {
            await upload(file, setPercent);
            onUploaded?.();
        } catch {
            // hata mesajı uploadRequest tarafından gösterildi
        } finally {
            setPercent(null);
        }
    };

    return (
        <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <input
                ref={inputRef}
                type="file"
                accept={accept}
                style={{ display: 'none' }}
                onChange={handleChange}
            />
            <Button
                size={size}
                icon={<UploadOutlined />}
                disabled={disabled || percent !== null}
                onClick={() => inputRef.current?.click()}
            >
                {label ?? t('Upload zip')}
            </Button>
            {percent !== null && <Progress percent={percent} size="small" />}
        </Space>
    );
}
